<template lang="pug">
  v-card.pa-2(  )
    v-form(ref='theForm', v-model='valid', lazy-validation='')
      .subtitle-1 Name
      v-row(no-gutters)
        v-col(cols="12" sm="6")
          v-text-field.pa-1(v-model='firstName', :counter='10', :rules='firstNameRules', label='First', 'required')
        v-col(cols="12" sm="6")
          v-text-field.pa-1(v-model='lastName', :counter='10', :rules='lastNameRules', label='Last', 'required')
      v-text-field(v-model='email', :rules='emailRules', label='E-mail', 'required')
      v-textarea(v-model='comment' :counter='300', :rules='commentRules', label='Comment' height="70" 'auto-grow')
    v-card-actions
      v-spacer
      v-btn(@click="onReset" color="info", light) Cancel
      v-btn(right color='secondary', @click='onSubmit')
        | Comment
</template>
<script>
import { sendEmail, regexPhone } from '../../plugins/mailer';
export default {
  data: () => ({
    valid: false,
    firstName: '',
    firstNameRules: [
      v => !!v || 'First Name is required',
      v => (v && v.length <= 20) || 'Name must be less than 20 characters'
    ],
    lastName: '',
    lastNameRules: [
      v => !!v || 'Last Name is required',
      v => (v && v.length <= 20) || 'Name must be less than 20 characters'
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    comment: '',
    commentRules: [
      v => (v && v.length <= 300) || 'Name must be less than 300 characters'
    ],
    select: null,
    selectRules: [v => !!v || 'Item is required'],
    items: [
      'Healing',
      'Encouragement',
      'Finances',
      'Relationship',
      'Family',
      'Depression/Suicide/Oppression',
      'Addiction',
      'Sexual Issues',
      'Grief',
      'Fear',
      'Hate',
      'Unforgiveness',
      'Stress',
      'Bitterness',
      'Shame',
      'Other'
    ],
    checkbox: false,
    checkBoxRules: [v => !!v || 'You must agree to continue!']
  }),

  methods: {
    onReset() {
      this.$refs.theForm.reset();
    },
    onSubmit() {
      this.valid = this.$refs.theForm.validate();
      console.log('Submitted');
      if (this.valid) {
        const to = 'bpj101@dameagnesproductions.com';
        const subj = 'A New Comment';
        let body = `
        <h2>This is a comment from <strong>${this.firstName} ${this.lastName}</strong></h2>
        <p>Comment:</p>
        <p><strong>${this.comment}</strong></p>
        `;
        /**
         * function for smtp.js plugin
         */
        sendEmail(to, subj, body);
      } else {
        alert('Please complet all required information in Event Request Form');
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>
